export const CANCELED = 'canceled';

export default {
  CANCELED,
};
